import { IonItem, IonRouterLink, IonText } from '@ionic/react';
import classNames from 'classnames';
import { Business, isBusinessOwner, isBusinessSubmitter } from 'model';
import { useHistory } from 'react-router';
import { useUserHasRole } from '../hooks/useUserHasRole';
import { getBusinessImages } from '../util/getBusinessImages';
// eslint-disable-next-line css-modules/no-unused-class
import styles from './BusinessItem.module.css';
import { ProfileImage } from './ProfileImage';
import { getInitials } from '../util/initials';
import { useCurrentUser } from '../hooks/useCurrentUser';
import { BusinessContextMenu } from './BusinessContextMenu';
import { PendingText } from './PendingText';
import GenericBusinessIcon from '../assets/buildingIcon.png';

export const BusinessItem: React.FC<{ business: Business }> = ({ business }) => {
	const user = useCurrentUser();
	const history = useHistory();
	const isAdmin = useUserHasRole('admin');
	const { logo } = getBusinessImages(business);
	const isPending = business.submissionStatus === 'pending';
	return (
		<div className={styles.container}>
			<IonItem className={classNames(styles.IonItem, 'pointer')}>
				<div className={styles.businessItem}>
					<IonRouterLink routerLink={`/main/bus/show/${business?._id}`}>
						<ProfileImage
							url={logo}
							text={getInitials(business.name)}
							size="small"
							shape="square"
							border
							background={business.logoBackgroundColor ?? 'transparent'}
							contain
							fallback={GenericBusinessIcon}
						/>
					</IonRouterLink>
					<div
						onClick={() => history.push(`/main/bus/show/${business._id}`)}
						style={{ width: '100%', padding: 5, paddingTop: 0, fontSize: 14 }}
					>
						<IonText className={styles.businessName}>
							{business?.name}
							{isPending && <PendingText small />}
						</IonText>
						<div className={styles.description}>{business?.description}</div>
					</div>
					{(isAdmin || isBusinessOwner(user, business) || isBusinessSubmitter(user, business)) && (
						<BusinessContextMenu business={business} context="list" />
					)}
				</div>
			</IonItem>
		</div>
	);
};
